var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-wrapper"},[_c('base-heading',{directives:[{name:"animate",rawName:"v-animate",value:(`slideLeft`),expression:"`slideLeft`"}],attrs:{"tag":"h1","heading":"title","subheading":"subtitle"}}),_c('cms-multi-section',{attrs:{"value":"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }